// removed by extract-text-webpack-plugin
module.exports = {"logo":"R8PNJqKJG_bTBRiMAQ1XD","main-header":"VzbyzHpEpz_vPlxEq3scP","base-nav-name":"_1lUBefKSyHsB5uq59ESYpx","use-menu":"_2OSd3v7W61JV7e-9YrvO-b","userStatus":"vcrmsMmCKGvZIEgrZdrDN","firstPop":"_3szkX3XQe_PI117zSnY6Vu","popContent":"_31paTPZEbhaTDC4c124YII","popArrow":"_1qPgjx8YUC5oU9yR_y75-k","popover":"_1RcmXqvF3f356DPbJbiBMe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/index.less
// module id = 388
// module chunks = 0